module.exports = __webpack_public_path__ + "img/78.b96175c9.png";